import TPEAction from 'src/models/common/TPEAction';
import { DerivedAllocationSheetBuilderState, initialState } from './DerivedAllocationSheetBuilderState';

export const ACTIONS = Object.freeze({
    SET_SHEET_RESULT: new TPEAction('SET_SHEET_RESULT'),
    SET_LOADING: new TPEAction('SET_LOADING'),
    SET_ERROR: new TPEAction('SET_ERROR'),
    SET_VIEW_MODE: new TPEAction('SET_VIEW_MODE'),
    SET_DATA_SOURCES: new TPEAction('SET_DATA_SOURCES'),
    REFRESH_SHEET: new TPEAction('REFRESH_SHEET'),
});

export function derivedAllocationSheetBuilderReducer(
    state: DerivedAllocationSheetBuilderState = initialState,
    action: TPEAction,
): DerivedAllocationSheetBuilderState {
    switch (action.type) {
        case ACTIONS.SET_SHEET_RESULT.type: {
            const { sheet, availableVersions } = action.payload ?? {};
            return {
                ...state,
                sheet: sheet ?? null,
                availableVersions: availableVersions ?? [],
                loading: false,
                error: undefined,
            };
        }
        case ACTIONS.SET_LOADING.type:
            return { ...state, loading: action.payload };
        case ACTIONS.SET_ERROR.type:
            return { ...state, error: action.payload, loading: false };
        case ACTIONS.SET_VIEW_MODE.type:
            return { ...state, viewMode: action.payload };
        case ACTIONS.SET_DATA_SOURCES.type:
            return { ...state, dataSources: action.payload ?? [] };
        case ACTIONS.REFRESH_SHEET.type:
            return { ...state, sheetRefreshToken: state.sheetRefreshToken + 1 };
        default:
            return state;
    }
}
